export default __webpack_public_path__ + "static/media/051-is less than or equal to.8ee00bf0.svg";